import { bool, func, number } from 'prop-types';
import React from 'react';
import { Button } from 'reactstrap';

import api from '../../REST/api';
import withApiRequest from '../../REST/with-api-request';

function DuplicateButton({ id, loading, onRequest, onSuccess, disabled }) {
  const onClick = () => onRequest({ id }).then(onSuccess).catch(console.error); // eslint-disable-line no-console

  return (
    <Button size="sm" onClick={onClick} disabled={loading || disabled}>
      Duplicate
    </Button>
  );
}

DuplicateButton.propTypes = {
  id: number.isRequired,
  loading: bool.isRequired,
  onRequest: func.isRequired,
  onSuccess: func.isRequired,
  disabled: bool.isRequired,
};

export default withApiRequest({
  query: api.duplicateQuote,
  successMessage: 'Quote duplicated',
  error: 'flash',
})(DuplicateButton);
